'use strict';
import React from 'react';
import flux from 'utils/flux';

var ShareItemRestricted = React.createClass({
    displayName: 'ShareItemRestricted',
    propTypes: {
        item: React.PropTypes.object
    },
    getInitialState() {
        return {
            isRequestingAccess: false
        }
    },
    requestAccess(e) {
        e.preventDefault();
        var item = this.props.item;
        if ( !item.get('access_requested') ) {
            this.setState({ isRequestingAccess: true });
            flux.getStore('share').requestAccess({ media_id: item.get('id') })
            .always( () => {
                this.setState({ isRequestingAccess: false });
            });
        }
    },
    render() {
        var item = this.props.item.toJSON();

        return(
            <div className="listing__item listing__item--restricted">
                <div className="item__preview item__preview--restricted">
                    <i className="lock"></i>
                </div>
                <div className="item__info">
                    <div className="info__top">
                        <h4 className="top__title">
                            {flux.t('restricted_asset_title')}
                        </h4>
                    </div>
                    <div className="item__description">
                        {flux.t('restricted_asset_description')}
                    </div>
                    <div className="listing__item--restricted__cta">
                        {!item.access_requested && <button disabled={this.state.isRequestingAccess} onClick={this.requestAccess} className="btn">{flux.t('restricted_asset_cta')}</button>}
                        {item.access_requested && flux.t('restricted_asset_access_requested')}
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = ShareItemRestricted;



// WEBPACK FOOTER //
// ./app/pages/share/shareItemRestricted.jsx